import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "o-form__modal__bg" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "o-form__modal" }
const _hoisted_4 = {
  key: 0,
  class: "o-text o-form__modal__inner"
}
const _hoisted_5 = { class: "o-button-group" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "o-text o-form__modal__inner"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "o-button-group" }
const _hoisted_13 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    "data-component-name": _ctx.$options.name
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!$data.result.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx._t('Attention, vous demandez la reprise d\'un formulaire sauvegardé.')), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString(_ctx._t('Êtes-vous certain de vouloir continuer avec la reprise?')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "o-button -button-stroke",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeModal && $options.closeModal(...args))),
                disabled: ($data.result.loading) ? 'disabled': false
              }, _toDisplayString(_ctx._t('Nouveau formulaire')), 9 /* TEXT, PROPS */, _hoisted_6),
              _createElementVNode("button", {
                class: "o-button",
                onClick: _cache[1] || (_cache[1] = (...args) => ($options.recoverForm && $options.recoverForm(...args))),
                disabled: ($data.result.loading) ? 'disabled': false,
                ref: "recoverButton"
              }, _toDisplayString(_ctx._t('Reprendre le formulaire')), 9 /* TEXT, PROPS */, _hoisted_7)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            ($data.result.status=='success')
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 0,
                  class: "recover-success",
                  innerHTML: $data.result.message
                }, null, 8 /* PROPS */, _hoisted_9))
              : (_openBlock(), _createElementBlock("h3", {
                  key: 1,
                  class: "recover-error",
                  innerHTML: $data.result.message
                }, null, 8 /* PROPS */, _hoisted_10)),
            ($data.result.messageAlt)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  innerHTML: $data.result.messageAlt
                }, null, 8 /* PROPS */, _hoisted_11))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "o-button",
                onClick: _cache[2] || (_cache[2] = (...args) => ($options.closeModal && $options.closeModal(...args))),
                disabled: ($data.result.loading) ? 'disabled': false,
                ref: "recoverCompleteButton"
              }, _toDisplayString(_ctx._t('Continuer')), 9 /* TEXT, PROPS */, _hoisted_13)
            ])
          ]))
    ])
  ], 8 /* PROPS */, _hoisted_1))
}